<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15.71,2.29C15.71,2.29,13.71,0.29,13.71,0.29C13.53,0.11,13.28,0,13,0C13,0,12,0,12,0C12,0,12,6,12,6C12,6,4,6,4,6C4,6,4,0,4,0C4,0,1,0,1,0C0.45,0,0,0.45,0,1C0,1,0,15,0,15C0,15.55,0.45,16,1,16C1,16,15,16,15,16C15.55,16,16,15.55,16,15C16,15,16,3,16,3C16,2.72,15.89,2.47,15.71,2.29C15.71,2.29,15.71,2.29,15.71,2.29ZM14,15C14,15,2,15,2,15C2,15,2,9,2,9C2,8.45,2.45,8,3,8C3,8,13,8,13,8C13.55,8,14,8.45,14,9C14,9,14,15,14,15C14,15,14,15,14,15ZM11,1C11,1,9,1,9,1C9,1,9,5,9,5C9,5,11,5,11,5C11,5,11,1,11,1C11,1,11,1,11,1Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'FloppyDisk',
} as DefineComponent
</script>
